export default __webpack_public_path__ + "static/media/admin-dispute.ae563a74.svg";